/**
 * Session-recording URL preference helper (#30070).
 *
 * Prefer Ryn Replay when a session is live, otherwise fall back to another
 * source. Call sites that historically used `WebSmartlookService` alone should
 * keep doing so — that service now forwards to Ryn Replay. This helper remains
 * for pure preference logic / tests. DTO fields stay `SmartlookURL` /
 * `smartlookURL` until the API contract is renamed (#30073).
 */
export interface ISessionRecordingUrlSource {
  sessionUrl(): string | undefined;
}

export const resolveSessionRecordingUrl = (
  rynReplay: ISessionRecordingUrlSource,
  smartlook: ISessionRecordingUrlSource
): string | undefined => rynReplay.sessionUrl() ?? smartlook.sessionUrl();
